module.exports = __webpack_public_path__ + "img/rank_captain.f3b0cae5.svg";